import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {ArtworkState, Manifest} from "./layered_static_v1";
import * as Comlink from 'comlink';
// eslint-disable-next-line import/no-webpack-loader-syntax
import Worker from "worker-loader!./RenderWorker";
import {ArtworkSimple} from "./RenderWorker";
import {Remote} from "comlink";
import {css} from "@emotion/css";


/**
 * Canvas which shows a piece of async.art.
 */

export function Artwork(props: {
  master: any,
  manifest: Manifest,
  chainValues: ArtworkState,
  userValues: ArtworkState,
  className?: string
}) {
  const canvas = React.useRef<HTMLCanvasElement>();
  const [realWidth, setRealWidth] = useState(0);
  const [isRendering, setRendering] = useState(false);

  const fullState = useMemo(() => {
    return {...props.chainValues, ...props.userValues}
  }, [props.chainValues, props.userValues])


  // const renderArtwork = useCallback(async (state: any) => {
  //   if (!props.manifest) { return; }
  //   const r = new ArtworkSimple(props.manifest.layout, parseInt(props.master.id));
  //   return r.setState(state);
  // }, [props.master, props.manifest]);
  const renderArtwork = useWebworkerRenderer(props);

  useEffect(() => {
    if (!fullState  || !props.manifest) {
      return;
    }

    setRendering(true);
    renderArtwork(fullState).then((data: any) => {
      let imageData = new ImageData(
          new Uint8ClampedArray( data.buffer ),
          data.width,
          data.height
      );
      canvas.current!.width = data.width;
      canvas.current!.height = data.height;
      canvas.current!.getContext('2d')!.putImageData(imageData, 0, 0);
      setRealWidth(data.width);
      setRendering(false);
    });
  }, [renderArtwork, fullState, props.manifest])

  return <div className={props.className}>
    <div className={css`
      position: relative;
    `}>
      <canvas ref={canvas as any} style={{width: '100%', maxHeight: '100%', maxWidth: realWidth}}/>
      {(isRendering) ? <div className={css`
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgb(79 78 79 / 61%);
        color: white;
        padding: 0.3em;
      `}>
        Rendering...
      </div> : null}
    </div>
  </div>
}


function useWebworkerRenderer(props: {
  master: any,
  manifest: Manifest,
}) {
  type Instance = {comlink: Remote<ArtworkSimple>, worker: Worker};

  const instance = useRef<Instance|null>(null);

  return useCallback(async (state: any) => {
    if (instance.current) {
      console.log('Terminating worker')
      instance.current.worker.terminate();
      instance.current = null;
    }

    const worker = new Worker();
    const ArtworkRendererLink = Comlink.wrap<typeof ArtworkSimple>(worker);
    const comlinkP = new ArtworkRendererLink(props.manifest.layout, parseInt(props.master.id));

    const comlink = await comlinkP;
    instance.current = {comlink, worker};

    return await comlink.setState(state)
  }, [props.master, props.manifest]);
}


export class ErrorBoundary extends React.Component {
  state: any;

  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.log(error);
    console.log(errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}